export const environment = {
  production: true,
  // apiUrl: 'http://localhost:3000',
  apiUrl: 'https://admin-api2.imodigi.com',
  dirProfileImage: 'users/files',
  dirLogoImage: 'entities/files',
  dirLogoStoreImage: "entities/store/files",
  dirBlogImage: "blog/files",
  pagesLoading: [
    "/menus", "/users", "/imo-modules", "/entities", "/properties",
    "/agents", "/leads", "/deals", "/calendar", "/contacts", "/permissions-for-entity",
    "/app-config", "/newsletter", "/reports", "/sales-processing", "/portals",
    "/proposals", "/dashboard", "/register-book", "/activity-logs", "/academy"
  ],
  dirPropertiesImages: '/properties/image',
  dirContactsfiles: '/contacts/file',
  dirLocationsfiles: '/locations/file',
  dirBannersfiles: '/entities/banners',
  dirBlogFiles: '/blog-imodigi/files/',
  dirDealsFiles: '/deals/document/',
  chat: 'https://admin-api2.imodigi.com',
  // FgEmojiPickerDir: "https://admin.imodigi.com/chat/assets/"
  // chat: 'http://localhost:3002',
  chatPath: '/chatv2/socket.io',
  FgEmojiPickerDir: "https://admin-api2.imodigi.com/chat/assets/",
  dirChatFiles: 'https://admin-api2.imodigi.com/chatv2/chat/file/',
  dirPropertiesDocs: '/properties/document',
  notifictionPath: '/real-time/socket.io',
  notificationUrl: 'https://admin-api2.imodigi.com',
  portal: {
    imovirtual: {
      authorizationUrl: "https://www.imovirtual.com/pt/crm/authorization/?response_type=code&client_id=<YOUR CLIENT ID>&state=<USER ID>",
      clientID: ""
    }
  }
};
